import * as Yup from "yup";
import {
  cvrField,
  emailOptional,
  emailRequired,
  employeeListWhen,
  invoiceDispatchFields,
  jaNej,
  pNumberField,
  phoneField,
  phoneFieldOptional,
  remarksAndContactFields,
  requiredDate,
  SELECT_REQUIRED_MESSAGE,
} from "./registrationValidationShared";
import {
  CompanyForm,
  JaNej,
  ParticipantType,
} from "../model/registrationEnums";
import {
  creationParticipantEligibilityFields,
  creationVoteShareField,
  interessentskabParticipantEligibilityFields,
} from "../eligibility/participantEligibilityValidation";

const contactFields = {
  phone: phoneField,
  email: emailRequired,
  safetyEmail: emailOptional,
  website: Yup.string().url("Ugyldig hjemmeside.").notRequired().nullable(),
};

const insuranceFields = {
  insuranceCompany: Yup.string().notRequired(),
  insurancePolicyNumber: Yup.string().notRequired(),
};

export const enkeltmandsvirksomhedSchema = Yup.object({
  name: Yup.string().required("Virksomhedens navn er påkrævet."),
  cvr: cvrField,
  pNumber: pNumberField,
  ...contactFields,
  ...invoiceDispatchFields,
  cvrCreationDate: requiredDate,
  startDate: requiredDate,
  startFromOtherCompany: jaNej,
  otherCompanyName: Yup.string().when("startFromOtherCompany", {
    is: JaNej.Ja,
    then: (schema) => schema.required("Navn er påkrævet."),
    otherwise: (schema) => schema.notRequired(),
  }),
  otherCompanyEndDate: Yup.string().when("startFromOtherCompany", {
    is: JaNej.Ja,
    then: () => requiredDate,
    otherwise: (schema) => schema.notRequired(),
  }),
  employees: jaNej,
  employeeList: employeeListWhen("employees", phoneFieldOptional),
  ...insuranceFields,
  ...remarksAndContactFields,
});

const responsibleParticipant = Yup.object({
  participantType: Yup.string()
    .required("Type er påkrævet.")
    .oneOf([ParticipantType.Person, ParticipantType.Company], "Vælg type."),
  name: Yup.string().required("Navn er påkrævet."),
  email: emailRequired,
  cvrCpr: Yup.string().required("CVR/CPR er påkrævet."),
  phone: phoneField,
  ...interessentskabParticipantEligibilityFields,
});

export const interessentskabSchema = Yup.object({
  name: Yup.string().required("Virksomhedens navn er påkrævet."),
  cvr: cvrField,
  pNumber: pNumberField,
  ...contactFields,
  ...invoiceDispatchFields,
  responsibleParticipants: Yup.array()
    .of(responsibleParticipant)
    .min(2, "Der skal være mindst to ansvarlige deltagere."),
  cvrCreationDate: requiredDate,
  startDate: requiredDate,
  employees: jaNej,
  employeeList: employeeListWhen("employees", phoneFieldOptional),
  ...insuranceFields,
  ...remarksAndContactFields,
});

const shareholderRow = Yup.object({
  name: Yup.string().required("Navn på selskabsdeltager er påkrævet."),
  ...creationParticipantEligibilityFields,
  voteShare: creationVoteShareField,
  cvrCpr: Yup.string().required("CVR/CPR er påkrævet."),
});

export const advokatselskabSchema = Yup.object({
  name: Yup.string().required("Selskabets navn er påkrævet."),
  cvr: cvrField,
  pNumber: pNumberField,
  ...contactFields,
  ...invoiceDispatchFields,
  companyForm: Yup.string()
    .required("Selskabsform er påkrævet.")
    .oneOf(
      [CompanyForm.AS, CompanyForm.ApS, CompanyForm.PS],
      SELECT_REQUIRED_MESSAGE,
    ),
  shareholders: Yup.array()
    .of(shareholderRow)
    .min(1, "Angiv mindst én selskabsdeltager."),
  activePractice: jaNej,
  employees: jaNej,
  employeeList: employeeListWhen("employees", phoneFieldOptional),
  cvrCreationDate: requiredDate,
  startDate: requiredDate,
  ...insuranceFields,
  ...remarksAndContactFields,
});
